import React from 'react';
import { PDFPrintContainer } from './PDFPrintContainer';
import { PDFDocumentProxy } from 'pdfjs-dist';
import { IFramePortal } from '@readcloud/component-library';
import { reject } from 'ramda';

export type PrintRights = {
  printablePages: number[];
  printableRanges: string;
};

export const PDFPrintIframe = (props: {
  pdfDocument: PDFDocumentProxy;
  printRights?: PrintRights;
  printOptions?: boolean;
  printNumPages?: number;
  onClose: () => void;
  iosPrint?: (printHTML: string) => void;
}) => {
  //console.log('Options', props.printOptions, 'PR', props.printRights);

  const createNumPageRange = React.useRef([]);

  React.useEffect(() => {
    if (props.printNumPages && props.printNumPages > 0) {
      for (let i = 0; i < props.printNumPages; i++) {
        createNumPageRange.current.push(i);
      }
    }
  }, [props.printNumPages]);

  const printablePages = React.useMemo(() => {
    return props.printOptions && props.printNumPages
      ? createNumPageRange.current
      : props.printRights
      ? props.printRights.printablePages
      : [];
  }, [
    createNumPageRange.current,
    props.printOptions,
    props.printNumPages,
    props.printRights,
  ]);

  const printableRange = React.useMemo(() => {
    return props.printOptions && props.printNumPages
      ? '1-' + props.printNumPages
      : props.printRights
      ? props.printRights.printableRanges
      : '';
  }, [props.printOptions, props.printNumPages, props.printRights]);

  return (
    <IFramePortal className="rc-h-0 rc-w-0">
      {(iframe: any) =>
        iframe.contentWindow ? (
          <PDFPrintContainer
            window={iframe.contentWindow}
            printablePages={printablePages}
            performPrint={async () => {
              return await new Promise((resolve, reject) =>
                setTimeout(() => {
                  const printHTML =
                    iframe.contentWindow.document.documentElement.outerHTML;
                  props.iosPrint && props.iosPrint(printHTML);

                  if (iframe.contentWindow) {
                    //console.log(iframe.contentWindow);
                    //iframe.contentWindow.focus();
                    iframe.contentWindow.print();
                  }
                  return resolve();
                }, 500)
              );
            }}
            pdfDocument={props.pdfDocument}
            onBack={props.onClose}
            printableRanges={printableRange}
          />
        ) : (
          <div />
        )
      }
    </IFramePortal>
  );
};
